import { render, staticRenderFns } from "./inboundreport_main.vue?vue&type=template&id=4f3fb70a&scoped=true"
import script from "./inboundreport_main.vue?vue&type=script&lang=js"
export * from "./inboundreport_main.vue?vue&type=script&lang=js"
import style0 from "./inboundreport_main.vue?vue&type=style&index=0&id=4f3fb70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3fb70a",
  null
  
)

export default component.exports